export const ACCOUNT_DETAILS = 'FETCH_ACCOUNT_DETAILS';
export const CUSTOMER_ACCOUNT_OVERVIEWS = 'FETCH_CUSTOMER_ACCOUNT_OVERVIEWS';
export const IS_UPGRADABLE_ACCOUNT = 'FETCH_IS_UPGRADABLE_ACCOUNT';
export const IS_RENEWABLE_ACCOUNT = 'FETCH_IS_RENEWABLE_ACCOUNT';
export const IS_EVALUATION_ALLOWED = 'FETCH_IS_EVALUATION_ALLOWED';
export const CUSTOMER_ACCOUNT_OVERVIEWS_ASYNC = 'FETCH_CUSTOMER_ACCOUNT_OVERVIEWS_ASYNC';
